module.exports = __webpack_public_path__ + "img/27.da5768c8.png";